import React, { useEffect, useState } from "react";
import SingleImg from "./SingleImg";
import MuiltiImg from "./MuiltiImg";
import { serverAddress } from "../../config";
import { Global_Data } from "../../globalData/GlobalData";
import ComponentLoadingBoundary from "../Loading/ComponentLoadingBoundary";
import usePendingRequests from "../Loading/usePendingRequests";

function ImgComponent({
  setTextValue,
  formAction,
  textValue,
  value,
  imagesIdsFromMedia,
  setImagesIdsFromMedia,
  data,
  openStaticDialog,
  id,
  setUpdateImage = "",
  updateImage
}) {
  const { token } = Global_Data();
  const [featuredImg, setFeaturedImg] = useState({});
  const { loading, trackRequest } = usePendingRequests();
  //   useEffect(() => {
  //     if (imagesIdsFromMedia.length == 0 && value) {
  //       setImagesIdsFromMedia([{ sName: data?.component?.sName, data: [value] }]);
  //     }
  //   }, [value]);
  function processData(dataString) {
    if (dataString) {
      const parts = dataString?.split(/,\s*/);
      const result = {
        featured: null,
        data: []
      };
      for (let i = 0; i < parts.length; i++) {
        const trimmedPart = parts[i].trim();
        if (trimmedPart.includes(":Featured")) {
          result.featured = trimmedPart.replace(":Featured", "");
        } else {
          result.data.push(trimmedPart);
        }
      }
      return result;
    }
  }

  async function setFeaturedImgsSrc(item) {
    const requestOptions = {
      headers: {
        Authorization: `Bearer ${token}`
      }
    };
    try {
      const blob = await trackRequest(async () => {
        const response = await fetch(
          serverAddress + `/image/retrieve?imageid=${item}`,
          requestOptions
        );
        return response.blob();
      });
      const objectURL = URL.createObjectURL(blob);
      setFeaturedImg({ src: objectURL, imgID: item });
    } catch (error) {
      console.error("Error fetching image:", error);
      throw error;
    }
  }

  useEffect(() => {
    if (data?.component?.options?.mode == "SINGLE") {
      if (imagesIdsFromMedia?.length == 0 && value) {
        if (setImagesIdsFromMedia) {
          setImagesIdsFromMedia([{ sName: data?.component?.sName, data: [value] }]);
        }
      }
    } else {
      const processedData = processData(value);
      if (processedData) {
        let arr = processedData?.data.filter(item => item !== "");
        if (setImagesIdsFromMedia) {
          setImagesIdsFromMedia([
            {
              sName: data?.component?.sName,
              data: processedData?.featured ? [...arr, processedData?.featured] : [...arr]
            }
          ]);
        }
        setFeaturedImgsSrc(processedData.featured);
      }
    }
  }, [value]);

  return (
    <ComponentLoadingBoundary
      loading={loading}
      label={`Loading ${data?.component?.sName}`}
      minHeight={80}
      size={24}
    >
      {data?.component?.options?.mode === "SINGLE" ? (
        <SingleImg 
          data={data} 
          value={value} 
          id={id} 
          setUpdateImage={setUpdateImage} 
          updateImage={updateImage} 
        />
      ) : (
        <>
          <MuiltiImg 
            data={data} 
            featuredImgIDs={featuredImg} 
            imagesIdsFromMedia={imagesIdsFromMedia} 
            textValue={textValue} 
            id={id} 
          />
        </>
      )}
    </ComponentLoadingBoundary>
  );
}

export default ImgComponent;
